export const AD_REPORT_ATTEMPT = "AD_REPORT_ATTEMPT";
export const AD_REPORT_SUCCESS = "AD_REPORT_SUCCESS";
export const AD_REPORT_FAILED = "AD_REPORT_FAILED";
export const ADD_REPORT_FAILED = "ADD_REPORT_FAILED";
export const ADD_REPORT_SUCCESS = "ADD_REPORT_SUCCESS";
export const LOGOUT = "LOGOUT";